module.exports = __webpack_public_path__ + "img/KinokoTable51.6a6b3447.jpg";